"use client";

import { followCta } from "@/app/utilities/link";
import { PromoBanner, type PromoBannerProps } from "@/composites/foundation";

import type { PromoBannerContent } from "./read-promo-banner";

export type PromoBannerBlockProps = PromoBannerContent &
	Pick<PromoBannerProps, "tone">;

export function PromoBannerBlock(props: PromoBannerBlockProps): JSX.Element {
	return <PromoBanner {...props} onActionPress={followCta} />;
}
